import axios from "axios";
import tools from "./tools";
import { store } from "redux/store";
import { clearToken, setToken } from "redux/slices/app.slice";

const http = {
  get: httpRequest("get"),
  post: httpRequest("post"),
  put: httpRequest("put"),
  base: {
    api: process.env.REACT_APP_BASE_URL,
    refreshToken: `${process.env.REACT_APP_BASE_URL}api/Authentication/GetRefreshToken`,
  },
};

let refreshTokenPromise: any = null;

// refresh token promise as a singleton
async function refreshToken() {
  if (refreshTokenPromise) {
    return refreshTokenPromise;
  }

  refreshTokenPromise = Promise.resolve().then(async () => {
    try {
      const response = await axios.post(
        http.base.refreshToken,
        {
          id: localStorage.refresh_token,
          clientId: process.env.REACT_APP_CLIENT_ID,
          grantType: "refresh_token",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );

      if (response.data.code === 401) {
        throw response.data.message; // login from sso iframe
      }

      store.dispatch(setToken(JSON.parse(response.data.data)));

      refreshTokenPromise = null;

      return response;
    } catch (error) {
      tools.alert.error(
        "نشست شما به پایان رسیده، لطفا دوباره وارد سامانه شوید."
      );
      store.dispatch(clearToken());

      throw error; // login from sso iframe
    } finally {
      refreshTokenPromise = null;
    }
  });

  return refreshTokenPromise;
}
function httpRequest(method: any) {
  async function request({
    base = http.base.api,
    url = "",
    data = {},
    formData,
    params = {},
    signal,
  }: {
    base?: string;
    url?: string;
    data?: any;
    formData?: any;
    params?: any;
    signal?: AbortSignal;
  }) {
    // set request headers
    const headers = {
      Accept: "application/json",
      ApplicationID: process.env.REACT_APP_APPLICATION_ID,
      Authorization: localStorage.token ? `Bearer ${localStorage.token}` : null,
      ClientID: process.env.REACT_APP_CLIENT_ID,
      "Content-Type": "application/json",
    };

    // set request options
    const options: any = {
      baseURL: base,
      url: url,
      method: method,
      headers: headers,
      data: data,
      timeout: 60 * 1000,
      signal,
    };
    if (formData) {
      headers["Content-Type"] = "multipart/form-data";
      options.data = formData;
    }
    if (method === "get" && params) {
      options.params = params;
    }

    try {
      const response = await axios(options);

      if (!response.data.success) {
        if (response.data.code === 403) {
          return response.data;
        } else {
          throw Error(response.data.message);
        }
      }

      return response.data;
    } catch (error: any) {
      // handle 401 unauthorized
      if (error.response?.status === 401) {
        try {
          await refreshToken();

          // retry request
          const newResponse: any = await request(options);
          return newResponse;
        } catch (error) {}
      } else {
        return Promise.reject({
          messages: tools.processError(error),
          keys: {},
        });
      }
    }
  }

  return request;
}

export default http;
